import { render, staticRenderFns } from "./CanaryMarker.vue?vue&type=template&id=b68aaab4&scoped=true"
import script from "./CanaryMarker.vue?vue&type=script&setup=true&lang=ts"
export * from "./CanaryMarker.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CanaryMarker.vue?vue&type=style&index=0&id=b68aaab4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b68aaab4",
  null
  
)

export default component.exports